import api from './api';

export interface PortalTableDto {
  tableName: string;
  description: string;
  rowCount: number;
}

export interface CheckHisTableResponse {
  exists: boolean;
  rowCount: number;
  tableName: string;
}

export interface CopyTableToHisResponse {
  success: boolean;
  tableName: string;
  rowsCopied: number;
  wasOverwritten: boolean;
  message: string;
}

export const syncService = {
    async syncHisEmployees(): Promise<void> {
        await api.post('/sync/his-employees');
    },

    async getPortalTables(): Promise<PortalTableDto[]> {
      const res = await api.get('/sync/portal-tables');
      // Map PascalCase (System.Text.Json mặc định) → camelCase cho phạm vi sync
      return (res.data || []).map((r: any) => ({
        tableName: r.tableName ?? r.TableName,
        description: r.description ?? r.Description,
        rowCount: Number(r.rowCount ?? r.RowCount ?? 0)
      }));
    },

    async checkHisTable(tableName: string): Promise<CheckHisTableResponse> {
      const res = await api.post('/sync/check-his-table', { tableName });
      const d: any = res.data || {};
      return {
        exists: Boolean(d.exists ?? d.Exists ?? false),
        rowCount: Number(d.rowCount ?? d.RowCount ?? 0),
        tableName: d.tableName ?? d.TableName ?? tableName
      };
    },

    async copyTableToHis(tableName: string, overwrite: boolean): Promise<CopyTableToHisResponse> {
      const res = await api.post('/sync/copy-table-to-his', { tableName, overwrite });
      const d: any = res.data || {};
      return {
        success: Boolean(d.success ?? d.Success ?? true),
        tableName: d.tableName ?? d.TableName ?? tableName,
        rowsCopied: Number(d.rowsCopied ?? d.RowsCopied ?? 0),
        wasOverwritten: Boolean(d.wasOverwritten ?? d.WasOverwritten ?? false),
        message: d.message ?? d.Message ?? ''
      };
    },
};
